export interface Verse {
  sanskrit: string;
  english: string;
}

// Well-known lines from the Bhagavad Gita and the Yoga Sutras; one per day, rotating.
const verses: Verse[] = [
  { sanskrit: 'Yogaḥ karmasu kauśalam', english: 'Yoga is skill in action.' },
  { sanskrit: 'Samatvaṃ yoga ucyate', english: 'Equanimity is called yoga.' },
  { sanskrit: 'Yogaś citta-vṛtti-nirodhaḥ', english: 'Yoga is the stilling of the fluctuations of the mind.' },
  { sanskrit: 'Sthira-sukham āsanam', english: 'The posture should be steady and comfortable.' },
  { sanskrit: 'Santoṣād anuttamaḥ sukha-lābhaḥ', english: 'From contentment, unsurpassed happiness is gained.' },
  { sanskrit: 'Uddhared ātmanātmānam', english: 'Lift yourself up by your own effort.' },
  { sanskrit: 'Lokāḥ samastāḥ sukhino bhavantu', english: 'May all beings everywhere be happy.' },
  { sanskrit: 'Abhyāsa-vairāgyābhyāṃ tan-nirodhaḥ', english: 'Through steady practice and non-attachment the mind becomes still.' },
  { sanskrit: 'Śraddhāvāñ labhate jñānam', english: 'The one with faith gains wisdom.' },
  { sanskrit: 'Heyaṃ duḥkham anāgatam', english: 'The pain that has not yet come can be avoided.' },
];

export function dailyVerse(now = new Date()): Verse {
  const start = new Date(now.getFullYear(), 0, 0);
  const day = Math.floor((now.getTime() - start.getTime()) / 86_400_000);
  return verses[day % verses.length];
}
